import { CubeIcon } from '@fronton/icons-react';
import { DesignRegistrationPanelStructure } from 'common/components/design-registration-panel';

export const KITCHEN_PANEL_TEXT = 'Бесплатное проектирование онлайн или в\u00A0магазине';
export const KITCHEN_PANEL_TEXT_KZ = 'Запишитесь на\u00A0бесплатное проектирование';

export const KITCHEN_PANEL_STRUCTURE: DesignRegistrationPanelStructure = {
  panel: {
    content: {
      leftIcon: CubeIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: '',
    },
    actionBlock: [],
  },
  mobilePanel: {
    content: {
      icon: CubeIcon,
      iconColor: 'accent-primary',
      iconType: 'duotone',
      text: '',
    },
    mobileButton: {
      elementBlock: 'landingProektKuhni',
      openModal: true,
      label: 'Записаться на проектирование',
    },
    actionBlock: [],
  },
};
